import { render, staticRenderFns } from "./ListPengembalian.vue?vue&type=template&id=2a8da38a&scoped=true&"
import script from "./ListPengembalian.vue?vue&type=script&lang=js&"
export * from "./ListPengembalian.vue?vue&type=script&lang=js&"
import style0 from "./ListPengembalian.vue?vue&type=style&index=0&id=2a8da38a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8da38a",
  null
  
)

export default component.exports